<template>
  <div class="main-header__search-bar">
    <form @submit.prevent="onSearch">
      <label for="search">
        <i class="icon-search"></i>
      </label>
      <b-input
        v-auto-focus
        type="text"
        :placeholder="$trans('search.form.placeholder')"
        v-model="query"
        id="search"
      />
      <span class="main-header__offcanvas__close" @click="onClose"></span>
    </form>
  </div>
</template>

<script>
export default {
  name: "AppSearchBar",
  methods: {
    onSearch() {
      this.$emit("input", this.query);
    },
    onClose() {
      this.query = null;
      this.$emit("close");
    },
  },
  data() {
    return {
      query: null,
    };
  },
};
</script>
